import { CreateJoinProjectDomainValidationFailureReasonEnum } from "../types/joinProject";

const joinProjectDomainValidationFailureReason = (blocker: CreateJoinProjectDomainValidationFailureReasonEnum): string => {
    switch (blocker) {
        case CreateJoinProjectDomainValidationFailureReasonEnum.Indeterminate: return "Indeterminate validation failure";
        case CreateJoinProjectDomainValidationFailureReasonEnum.ProjectNotFound: return "Project not found";
        case CreateJoinProjectDomainValidationFailureReasonEnum.SubscriptionTypeNone: return "User does not have a subscription";
        case CreateJoinProjectDomainValidationFailureReasonEnum.AuthenticatedUserDoesNotHavePermission: return "You do not have permission to add this user";
        case CreateJoinProjectDomainValidationFailureReasonEnum.ContactEmailDomainDoesNotMatchProjectDomain: return "Invalid email domain, does not match project domain";
        case CreateJoinProjectDomainValidationFailureReasonEnum.InFlightManagedProcesses: return "User has existing managed processes";
        case CreateJoinProjectDomainValidationFailureReasonEnum.AlreadyJoiningProject: return "User is already joining this project";
        case CreateJoinProjectDomainValidationFailureReasonEnum.AlreadyMemberOfProject: return "User is already a member of this project";        
        default: return "An error occurred";
    }
};

export {
    joinProjectDomainValidationFailureReason
};
